/* hs-eslint ignored failing-rules */

/* eslint-disable no-prototype-builtins */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import UISelect from 'UIComponents/input/UISelect';
import { retrieveSchema, ADDITIONAL_PROPERTY_FLAG, getIsPropertyRequired } from '../../utils/schemaUtils';
import { getDefaultFormState } from '../../utils/defaults';
import { getAvailableKey } from '../../utils/additionalPropertyUtils';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SchemaField from './SchemaField';
import DescriptorBlock from './shared/DescriptorBlock';
export default class ObjectOneOfField extends Component {
  constructor(props) {
    super(props);

    this.createKeyChangeHandler = oldValue => {
      return value => {
        if (oldValue === value) {
          return;
        }

        const {
          formData
        } = this.props;
        value = getAvailableKey(value, formData);
        const newFormData = Object.assign({}, formData);
        const newKeys = {
          [oldValue]: value
        };
        const keyValues = Object.keys(newFormData).map(key => {
          const newKey = newKeys[key] || key;
          return {
            [newKey]: newFormData[key]
          };
        });
        const renamedObj = Object.assign({}, ...keyValues);
        this.props.onChange(renamedObj, this.props.errorSchema);
      };
    };

    this.createPropertyChangeHandler = (name, addedByAdditionalProperties = false) => {
      return (value, errorSchema) => {
        const {
          formData
        } = this.props;

        if (!value && addedByAdditionalProperties) {
          // Don't set value = undefined for fields added by
          // additionalProperties. Doing so removes them from the
          // formData, which causes them to completely disappear
          // (including the input field for the property name). Unlike
          // fields which are "mandated" by the schema, these fields can
          // be set to undefined by clicking a "delete field" button, so
          // set empty values to the empty string.
          value = '';
        } else if (value === null) {
          value = undefined;
        } else if (value.properties && formData.properties) {
          // Sometimes Object properties that already have a properties param will
          // be updated. In order to prevent this param from being duplicated,
          // we need to remove one of the properties params.
          value = value.properties;
        }

        const newFormData = Object.assign({}, formData, {
          [name]: value
        });
        this.props.onChange(newFormData, errorSchema && this.props.errorSchema && Object.assign({}, this.props.errorSchema, {
          [name]: errorSchema
        }));
      };
    };

    this.changeSelectedType = index => {
      const {
        registry,
        schema
      } = this.props;
      const {
        definitions
      } = registry;

      if (schema.oneOf[index]) {
        this.props.onChange(getDefaultFormState(schema.oneOf[index], undefined, definitions));
      } else {
        this.props.onChange([]);
      }
    };

    this.state = {
      oneOfTypes: props.schema.oneOf.map((item, i) => {
        const refParts = item.$$ref.split('/');
        const refName = refParts[refParts.length - 1];
        return {
          text: refName,
          value: i
        };
      }),
      selectedType: null
    };
  }

  render() {
    const {
      errorSchema,
      formData,
      idPrefix,
      idSchema,
      readOnly,
      registry,
      schemaGroup
    } = this.props;
    const {
      oneOfTypes,
      selectedType
    } = this.state;
    const {
      definitions
    } = registry;
    const schema = retrieveSchema(this.props.schema, definitions, formData);
    const selectedProperties = selectedType !== null ? schema.oneOf[selectedType].properties : {};
    const properties = Object.keys(selectedProperties).map(name => {
      const addedByAdditionalProperties = schema.oneOf[selectedType].properties[name].hasOwnProperty(ADDITIONAL_PROPERTY_FLAG);
      return /*#__PURE__*/_jsx(SchemaField, {
        errorSchema: errorSchema[name],
        formData: (formData || {})[name],
        idPrefix: idPrefix,
        idSchema: idSchema[name],
        name: name,
        onChange: this.createPropertyChangeHandler(name, addedByAdditionalProperties),
        onKeyChange: this.createKeyChangeHandler(name),
        readOnly: readOnly,
        registry: registry,
        required: getIsPropertyRequired(schema.oneOf[selectedType], name),
        schema: schema.oneOf[selectedType].properties[name],
        schemaGroup: schemaGroup
      }, name);
    });
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: "params-row",
        children: /*#__PURE__*/_jsxs("div", {
          className: "params-pair",
          children: [/*#__PURE__*/_jsx(DescriptorBlock, {
            id: idSchema.$id,
            label: I18n.text('developer-docs-shared-components.oneOfObject.label'),
            schema: schema
          }), /*#__PURE__*/_jsx("div", {
            className: "params-content m-bottom-3",
            children: /*#__PURE__*/_jsx(UISelect, {
              options: oneOfTypes,
              placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "developer-docs-shared-components.oneOfObject.placeholder"
              }),
              value: selectedType,
              onChange: evt => {
                this.setState({
                  selectedType: evt.target.value === '' ? null : evt.target.value
                });
                this.changeSelectedType(evt.target.value);
              },
              clearable: true,
              menuWidth: "auto"
            })
          })]
        })
      }), selectedType !== null && properties]
    });
  }

}
ObjectOneOfField.propTypes = {
  errorSchema: PropTypes.object,
  formData: PropTypes.any,
  idPrefix: PropTypes.string,
  idSchema: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  registry: PropTypes.object.isRequired,
  schema: PropTypes.object.isRequired,
  schemaGroup: PropTypes.string
};